import React, { useMemo } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import AppLayout from './containers/AppLayout/AppLayout';
import {
  SharedContextProvider,
  useSharedContext,
} from './contexts/SharedContext';

import store from './redux/store';
import './normalize.css';
import './index.css';

const StripeElementsBridge = ({ children }) => {
  const { stripePublicKey } = useSharedContext();
  const stripePromise = useMemo(
    () => (stripePublicKey ? loadStripe(stripePublicKey) : null),
    [stripePublicKey]
  );
  return <Elements stripe={stripePromise}>{children}</Elements>;
};

function App() {
  return (
    <Provider store={store}>
      <SharedContextProvider>
        <StripeElementsBridge>
          <BrowserRouter>
            <AppLayout />
          </BrowserRouter>
        </StripeElementsBridge>
      </SharedContextProvider>
    </Provider>
  );
}

export default App;
